import { createContext, useContext } from "react";
import { network } from "../schemas/elements";

export interface SnackbarState {
  children: React.ReactNode;
  severity: "error" | "warning" | "info" | "success";
}

export interface MapaContextType {
  mapId: string | undefined;
  tipo: string;
  elements: Map<string, any>;
  setElements: React.Dispatch<React.SetStateAction<Map<string, any>>>;
  elementSelected: any | null;
  setElementSelected: React.Dispatch<React.SetStateAction<any | null>>;
  connections: Map<string, any>;
  setConnections: React.Dispatch<React.SetStateAction<Map<string, any>>>;
  connectionSelected: any | null;
  setConnectionSelected: React.Dispatch<React.SetStateAction<any | null>>;
  hostGroups?: string[];
  editMode: boolean;
  setEditMode: React.Dispatch<React.SetStateAction<boolean>>;
  checkChanges: boolean;
  setCheckChanges: React.Dispatch<React.SetStateAction<boolean>>;
  snackbar: SnackbarState | null;
  setSnackbar: React.Dispatch<React.SetStateAction<SnackbarState | null>>;
  updateDataElementSocket: () => Promise<void>;
  configurationMap: any;
  setConfigurationMap: React.Dispatch<React.SetStateAction<any>>;
  mapRef?: React.RefObject<any>;
  hostsDataMap: Map<string, network.monitor.IHost[]>;
  alertsDataMap: Map<string, network.monitor.IAlert[]>;
  configElementDataMap: Map<string, network.monitor.IConfig>;
  connectionsDataMap: Map<string, network.monitor.IConnection>;
  lastCollectData: Date | null;
  connectionsDataMapPercentTraffic: Map<string, string[]>;
  connectionsDataMapPercentPower: Map<string, string[]>;
  rulerMode?: boolean;
  setRulerMode?: React.Dispatch<React.SetStateAction<boolean>>;
  startMapRef?: React.MutableRefObject<boolean>;
  soundState: boolean;
  setSoundState: React.Dispatch<React.SetStateAction<boolean>>;
  isPublic?: boolean;
}

export const MapaContext = createContext<MapaContextType | null>(null);

export const useMapa = (): MapaContextType => {
  const context = useContext(MapaContext);
  if (!context) {
    throw new Error("useMapa deve ser usado dentro de um <MapaProvider>");
  }
  return context;
};
